"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    toastBodyClassNames: function() {
        return toastBodyClassNames;
    },
    useToastBodyStyles_unstable: function() {
        return useToastBodyStyles_unstable;
    }
});
const _react = require("@griffel/react");
const toastBodyClassNames = {
    root: 'fui-ToastBody',
    subtitle: 'fui-ToastBody__subtitle'
};
const useRootBaseClassName = /*#__PURE__*/ (0, _react.__resetStyles)("rciajo9", null, [
    ".rciajo9{grid-column-start:2;grid-column-end:3;padding-top:6px;font-size:var(--fontSizeBase300);line-height:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);color:var(--colorNeutralForeground1);word-break:break-word;}"
]);
const useSubtitleBaseClassName = /*#__PURE__*/ (0, _react.__resetStyles)("rzjw1xk", null, [
    ".rzjw1xk{padding-top:4px;grid-column-start:2;grid-column-end:3;font-size:var(--fontSizeBase200);line-height:var(--fontSizeBase200);font-weight:var(--fontWeightRegular);color:var(--colorNeutralForeground2);}"
]);
const useInvertedStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        sj55zd: "f1w7i9ko"
    },
    subtitle: {
        sj55zd: "f1w7i9ko"
    }
}, {
    d: [
        ".f1w7i9ko{color:var(--colorNeutralForegroundInverted2);}"
    ]
});
const useToastBodyStyles_unstable = (state)=>{
    'use no memo';
    const rootBaseClassName = useRootBaseClassName();
    const subtitleBaseClassName = useSubtitleBaseClassName();
    const invertedStyles = useInvertedStyles();
    state.root.className = (0, _react.mergeClasses)(toastBodyClassNames.root, rootBaseClassName, state.backgroundAppearance === 'inverted' && invertedStyles.root, state.root.className);
    if (state.subtitle) {
        state.subtitle.className = (0, _react.mergeClasses)(toastBodyClassNames.subtitle, subtitleBaseClassName, state.backgroundAppearance === 'inverted' && invertedStyles.subtitle, state.subtitle.className);
    }
    return state;
}; //# sourceMappingURL=useToastBodyStyles.styles.js.map
